<template>
  <div>
    <DocsHeader />
    <div class="row main-row row-eq-height">
      <div id="multicolorengine_nav" class="col-xs-12 col-md-3 side-nav-outer">
        <h5>MulticolorEngine</h5>
        <hr />
        <div id="side-nav-main">
          <ul>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/what_is_multicolorengine' }"
                >What is MulticolorEngine?</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/release_notes' }"
                >Release notes</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/getting_started' }"
                >Getting started</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/working_with_images' }"
                >Working with images</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/color_classes' }"
                >Color classes</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/working_with_metadata' }"
                >Working with metadata</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/security_and_privacy' }"
                >Security and privacy</router-link
              >
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/faqs' }">FAQs</router-link>
            </li>
            <li>
              <router-link class="md" :to="{ name: 'multicolorengine/api_reference' }"
                >API reference</router-link
              >
            </li>
          </ul>
        </div>
        <div id="api-ref-nav">
          <ul>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/add' }">POST add</router-link>
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/delete' }"
                >GET delete</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/color_search' }"
                >POST color_search</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/extract_image_colors' }"
                >POST extract_image_colors</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/count_image_colors' }"
                >POST count_image_colors</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/extract_collection_colors' }"
                >GET extract_collection_colors</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/count_collection_colors' }"
                >GET count_collection_colors</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/count_metadata' }"
                >GET count_metadata</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/update_metadata' }"
                >POST update_metadata</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/get_metadata' }"
                >GET get_metadata</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/get_search_metadata' }"
                >GET get_search_metadata</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/get_return_metadata' }"
                >GET get_return_metadata</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/count' }"
                >GET count</router-link
              >
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/list' }">GET list</router-link>
            </li>
            <li>
              <router-link class="sm" :to="{ name: 'multicolorengine/ping' }">GET ping</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-1 empty-col" />
      <router-view class="col-md-7 col-xs-12 main-content-col" />
      <div class="col-md-1 empty-col" />
    </div>
  </div>
</template>

<script>
import DocsHeader from "@/components/DocsHeader.vue";

export default {
  components: { DocsHeader },
};
</script>

<style>
.empty-col {
  z-index: -1;
}
</style>
